<script>
import "./vfigma.input.scss";

export default {
  // props: ["input", "placeholder", "disabled", "enter", "esc", "optional", "focus", "change"],
  props: {
    disabled: Boolean,
    enter: Function,
    esc: Function,
    optional: Boolean,
    focus: Function,
    title: String,
    date: Date,
    click: Function,
    readonly: Boolean,
    error: Boolean
  },
  data() {
    return {
      value: '',
      focused: false,
      input: "",
    };
  },
  methods: {
    keyup: function ($event) {
      if ($event.which == 13) {
        $($event.target).change();
      }
    },
    stepUp: function ($event) {
      if (this.input == this.max) return;
      this.value = this.value + 1;
    },
    stepDown: function ($event) {
      if (this.input == "00:00:00") return;
      if (this.input == this.min) return;
      this.value = this.value - 1;
    },
    change(v) {
      console.log('change ?', v)
      this.$emit('update:date', v)
    }
  },
  mounted: function () {
    if (this.date) {
      this.$refs.inputDate.valueAsDate = this.date
    }
  },
  watch: {
    date() {
      if (this.date) {
      this.$refs.inputDate.valueAsDate = this.date
    }
    }
  }
};
</script>

<template>
  <div class="f-date">
    <f-field :optional="optional" :focused="focused">
      <template v-slot:label><slot name="label"></slot></template>
      <template v-slot:content>
        <div class="f-input-container" :class="{ focus: focused, error: error }">
          <input
          ref="inputDate"
            type="date"
            class="keepfocus f-input"
            :valueAsDate="value"
            :disabled="disabled"
            :readonly="readonly"
            :title="title"
            @keyup="keyup($event)"
            @focus="
              focused = true;
              $emit('focus', $event);
            "
            @blur="
              focused = false;
              change($event.target.valueAsDate);
            "
            @change="change($event.target.valueAsDate)"
            @click="$emit('click', $event)"
            v-on:keyup.enter="$emit('enter')"
            v-on:keyup.esc="$emit('esc')"
          />
        </div>
      </template>
      <template v-slot:helper v-if="$slots.helper"
        ><slot name="helper"></slot
      ></template>
    </f-field>
  </div>
</template>

<style scoped lang="scss">
</style>